/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExternalServiceType = {
    Web: 'Web',
    AwsLambda: 'AwsLambda'
} as const;
export type ExternalServiceType = typeof ExternalServiceType[keyof typeof ExternalServiceType];


export function ExternalServiceTypeFromJSON(json: any): ExternalServiceType {
    return ExternalServiceTypeFromJSONTyped(json, false);
}

export function ExternalServiceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalServiceType {
    return json as ExternalServiceType;
}

export function ExternalServiceTypeToJSON(value?: ExternalServiceType | null): any {
    return value as any;
}

